<div class="flex items-center gap-3 mt-2 pl-8 text-font-tertiary">
  @for (item of breadcrumbs; track item.label; let idx = $index) {
    @if (idx > 0) {
      <div class="text-xs">
        <rkt-icon name="chevron-right"></rkt-icon>
      </div>
    }

    @if (item.url) {
      <a [routerLink]="item.url" class="hover:text-primary" [title]="item.label">{{ item.label }}</a>
    } @else {
      <div class="text-font-primary">{{ item.label }}</div>
    }
  }
</div>
